import { Head, Link, usePage } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import JobWorkspace from "@/components/job-workspace";
import { locationJobActivityPath } from "@/routes";
import { dateTime } from "./types";
export default function JobActivity({
  events,
  pagination,
}: {
  events: {
    id: string;
    action: string;
    kind: string;
    at: string;
    actor: string | null;
    board_move: boolean;
    assignment: boolean;
  }[];
  pagination: { page: number; pages: number };
}) {
  const { auth, i18n, job_context: job } = usePage().props;
  const { t } = useTranslation();
  if (!job || !auth.location) return null;
  return (
    <JobWorkspace>
      <Head title={t("workspace.tabs.activity")} />
      <section className="space-y-4">
        <h2 className="text-section font-semibold">
          {t("workspace.tabs.activity")}
        </h2>
        {!events.length && <p>{t("workspace.no_activity")}</p>}
        <ol className="divide-y rounded-lg border">
          {events.map((event) => (
            <li key={event.id} className="space-y-1 p-4">
              <p className="font-medium">
                {t(
                  event.assignment
                    ? "workspace.assigned"
                    : event.board_move
                      ? "workspace.reordered"
                      : `workspace.events.${event.action}`,
                  { defaultValue: t("workspace.events.updated") },
                )}{" "}
                ·{" "}
                {t(`workspace.kinds.${event.kind}`, {
                  defaultValue: event.kind,
                })}
              </p>
              <p className="text-muted-foreground text-sm">
                {event.actor || t("workspace.system")} ·{" "}
                {dateTime(event.at, job.time_zone, i18n.locale)}
              </p>
            </li>
          ))}
        </ol>
        <nav
          aria-label={t("workspace.tabs.activity")}
          className="flex flex-wrap gap-4"
        >
          {pagination.page > 1 && (
            <Link
              className="underline"
              href={locationJobActivityPath(auth.location.id, job.id, {
                page: pagination.page - 1,
              })}
            >
              {t("customers.previous")}
            </Link>
          )}
          {pagination.page < pagination.pages && (
            <Link
              className="underline"
              href={locationJobActivityPath(auth.location.id, job.id, {
                page: pagination.page + 1,
              })}
            >
              {t("customers.next")}
            </Link>
          )}
        </nav>
      </section>
    </JobWorkspace>
  );
}
